import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { 
  itemsSearch, 
  itemsSku, 
  getDexWallet,
  itemsRank,
  createDexWallet
} from "../../../services/app";
import { useNavigate } from "react-router-dom";

import ItemPrime from "../../../components/ItemPrime";
import { RowFilter } from "./RowFilter";
import Filter from "./filter/Filter";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import {ModalMintNotify} from "../../../components/ModalMintNotify";
import * as Notification from "../../../Notification";

import {
  PRIME_DEFAULT_PARAMS,
  ITEM_TYPES,
  ITEM_LIMIT,
} from "../../../constants";
import { useWindowSize } from "../../../hook/useWindowSize";
import FilterMobile from "./filter/FilterMobile";

export const TabPrime = (props) => {
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const { T, setLoading, language, user, convertToLocalCurrency,formatLocalCurrency,
    getCurrency } = useApp();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataTab, setDataTab] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [isShowCreateWeb3, setIsShowCreatWeb3] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreatWeb3Success] = useState(false);
  const [breedOptions, $breedOptions] = useState([]);
  const [rankOptions, $rankOptions] = useState([]);
  const [isBtnLoading, $isBtnLoading] = useState();
  const [filterData, $filterData] = useState({
    ...PRIME_DEFAULT_PARAMS,
    size: ITEM_LIMIT,
    itemTypes: [ITEM_TYPES.ITEM_TYPE_PRIME],
  });
  const navigate = useNavigate();
  useEffect(() => {
    itemsSku(ITEM_TYPES.ITEM_TYPE_PRIME).then((res) => {
      const data = res?.data?.data || [];
      $breedOptions(data);
    });
  }, []);
  const [filterDataCache, $filterDataCache] = useState(filterData);

  const loadData = async () => {
    setLoading(true);
    const result = await itemsSearch({...filterData });
    setDataTab(result?.data?.data?.items?.rows || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setLoading(false);
  };
  const loadMore = async () => {
    setLoading(true);
    const result = await itemsSearch({
      ...filterData,
      page: page + 1,
    });
    setDataTab((prev) => [...prev, ...result?.data?.data?.items?.rows] || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setPage(page + 1);
    setLoading(false);
  };
  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };
  const handleFilterData = (val) => {
    $filterData({ ...filterData, ...val });
  };
  const handleCacheFilter = (val) => {
    $filterDataCache(val);
  };
  useEffect(() => {
    loadData();
  }, [filterData]);

  return (
    <div className="flex flex-col gap-[16px] xls:gap-[20px] xls:mt-[10px]">
      <div className="search-input relative">
        <RowFilter
          handleShowFilter={handleShowFilter}
          showFilter={showFilter}
          filterData={filterData}
          type={"nft_prime"}
          setFilterData={handleFilterData}
        />
        {isMobile && (
          <FilterMobile
            setFilterData={(val) => handleFilterData(val)}
            setCacheFilter={(val) => handleCacheFilter(val)}
            filterData={filterData}
            breedOptions={breedOptions}
            showing={9}
            type={"nft_prime"}
          />
        )}
      </div>
      <div className="flex justify-between items-start gap-[40px]">
        {showFilter && !isMobile && (
          <div className="w-[270px] hidden lg:block">
            <Filter
              setFilterData={(val) => handleFilterData(val)}
              filterData={filterData}
              showing={9}
              breedOptions={breedOptions}
              rankOptions={rankOptions}
              type={"nft_prime"}
            />
          </div>
        )}
        <div className={`flex-1 ${!showFilter ? "w-full" : ""}`}>
          <div className="asset-block">
            <div className="flex justify-between items-center">
              <div className="mb-[15px] text-base text-black font-[700]">
                {T("Total item: {count}").replace("{count}", total)}
              </div>
            </div>
            {dataTab?.length > 0 ? (
              <>
                <div
                  className={`grid gap-[15px] grid-cols-1 sm:grid-cols-2 xs:gap-[10px] ${
                    showFilter ? "lg:grid-cols-2 2xl:grid-cols-3" : "lg:grid-cols-3 2xl:grid-cols-4"
                  } lg:gap-[15px] xl:gap-[30px]`}
                >
                  {dataTab.map((item, index) => (
                    <ItemPrime
                      key={index}
                      itemData={item}
                      categoryTypes={breedOptions}
                    />
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
                  <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                    <img
                      className="w-[100px] lg:w-[160px]"
                      src={"/assets/images/empty-table.png"}
                      alt=""
                    />
                  </div>
                  <div className="w-full flex justify-center mb-[15px]">
                    {T("You haven't got anything yet.")}
                  </div>
                  <a
                    href={`${user.store_shopify}?lang=${user.language}`}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-black leading-[45px] !text-white rounded-[15px] px-[20px] h-[45px] button-boxshadow"
                  >
                    {T("Go to Mall")}
                  </a>
                </div>
              </>
            )}
          </div>
          {total > page * filterData.size && (
            <>
              <div
                className="flex justify-center items-center mt-[40px] gap-[10px]"
                onClick={() => loadMore()}
              >
                {T("Load more")} <ArrowDownIcon />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
